<script>
export default {
    data() {
        return {
            routerData: [],
        };
    },
    watch: {
        $route(to, form) {
            this.getRoute(to);
        },
    },
    created() {
        this.getRoute(this.$route);
    },
    methods: {
        getRoute(route) {
            let routers = [];
            let matched = route.matched.filter(
                (item) => item.meta && item.meta.level
            );
            for (let i = 0; i < matched.length; i++) {
                if (matched.redirect) {
                    routers.push({
                        name: matched[i].name,
                        path: matched[i].redirect,
                    });
                } else {
                    routers.push({
                        name: matched[i].name,
                        path: matched[i].path,
                    });
                }
            }
            this.routerData = routers;
        },
    },
    render() {
        return (
            <el-breadcrumb separator-class="el-icon-arrow-right">
                {this.routerData.map((item, index, arr) => {
                    if (index == arr.length - 1) {
                        return (
                            <el-breadcrumb-item>{item.name}</el-breadcrumb-item>
                        );
                    } else {
                        return (
                            <el-breadcrumb-item to={item.path}>
                                {item.name}
                            </el-breadcrumb-item>
                        );
                    }
                })}
            </el-breadcrumb>
        );
    },
};
</script>